import { render } from "./ConsecutiveShiftsLimitIcon.vue?vue&type=template&id=1a4d51a4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__